import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import crContent from '../JSONData/clientReviews.json';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';
import listngImg1 from '../assets/images/listingImg1.jpg'
import listngImg2 from '../assets/images/listingImg2.jpg'
import listngImg3 from '../assets/images/listingImg3.jpg'
import { HiArrowLongRight } from "react-icons/hi2";
import config from '../config';
import axios from 'axios';
const ClientReviews = ({ reviews = [] }) => {
    const { lang } = useParams();
    const labels = (crContent && crContent[lang]) ? crContent[lang] : crContent.en;
    // const reviews = [
    //     {
    //         title: "Sed ut perspiciatis unde.",
    //         description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    //         name: "Another Client",
    //         image: listngImg1
    //     },
    //     {
    //         title: "Lorem ipsum dolor sit amet.",
    //         description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    //         name: "Client Name",
    //         image: listngImg2
    //     },
    //     {
    //         title: "Sed ut perspiciatis unde.",
    //         description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    //         name: "Another Client",
    //         image: listngImg3
    //     }
    // ];
    const [reviewsData, setReviewsData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    const fetchReviews = async () => {
        try {
            const response = await axios.get(`${config.BASE_URL}/api/admin/get-reviews`, { withCredentials: true });

            if (response.data) {
                setReviewsData(response.data);
            }

        } catch (err) {
            setError('Failed to fetch reviews');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchReviews();
    }, []);
    return (
        <>
            <div className={`reviews pt-30 pb-30 d-py-60`}>
                <div className="section-title d-pb-60">
                    <div className="container">
                        <div className="h3 fw-200">{labels.title} <span className='fw-300'>{labels.fromClients}</span></div>
                    </div>
                </div>
                <div className='slider-wrapper position-relative'>
                    <div className="swiper-button swiper-button-next button-block icon-block"><HiArrowLongRight /></div>
                    <Swiper
                        modules={[Navigation]}
                        navigation={{
                            nextEl: ".reviews .swiper-button-next"
                        }}
                        loop={true}
                        spaceBetween={10}
                        slidesPerView={1}
                        className="flex items-center"
                        breakpoints={{
                            768: {
                                slidesPerView: 1.3,
                                spaceBetween: 50,
                            }
                        }}
                    >
                        {Array.isArray(reviewsData) && reviewsData.map((review, idx) => (
                            <SwiperSlide key={idx}>
                                <div className='review-item'>
                                    <div className="grid-blocks d-grid d-column-2 gap-30 d-gap-50">
                                        <div className='grid-block d-pt-30 sm-order-2'>
                                            <div className="summary-block sm-px-30 d-pb-30 text-right d-ps-30">
                                                {/* <div className='h6'>{labels.clientReview}---</div> */}
                                                <h2 className='fw-300 mb-40'>“{review?.title}”</h2>
                                                <div className='text-block mb-40'>{review?.description}</div>
                                                {review?.clientname && (
                                                    <div className='h6 client-name'>{review?.clientname}</div>
                                                )}
                                            </div>
                                        </div>
                                        <div className='grid-block sm-order-1'>
                                            <div className='image-block h-0 position-relative'>
                                                <img src={review.image ? `${config.BASE_URL}${review.image}` : review.featuredImage ? `${config.BASE_URL}${review.featuredImage}` : listngImg1} alt="Client Review" className="cover position-absolute top-0 left-0" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </>
    )
}

export default ClientReviews